<app-feature-details-grid>
  <app-feature-list-container>
    <!-- heating.dhw.sensors.temperature.hotWaterStorage.bottom -->
    <app-feature-list-item
      *ngIf="storageTankSensorBottom$ | async | ready as feature"
      label="{{
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.BOTTOM_CYLINDER_TEMP_SENSOR'
          | translate
      }}:"
      [description]="
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.BOTTOM_CYLINDER_TEMP_SENSOR_TOOLTIP'
          | translate
      "
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>

    <!-- heating.dhw.sensors.temperature.hotWaterStorage.top -->
    <app-feature-list-item
      *ngIf="storageTankSensorTop$ | async | ready as feature"
      label="{{
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.TOP_CYLINDER_TEMP_SENSOR'
          | translate
      }}:"
      [description]="
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.TOP_CYLINDER_TEMP_SENSOR_TOOLTIP'
          | translate
      "
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    ></app-feature-list-item>

    <!-- heating.sensors.volumetricFlow.allengra -->
    <app-feature-list-item
      *ngIf="volumetricFlowReturn$ | async | ready as feature"
      label="{{
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.VOLUMETRIC_FLOW' | translate
      }}:"
      [description]="
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.VOLUMETRIC_FLOW_TOOLTIP'
          | translate
      "
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    ></app-feature-list-item>

    <!-- heating.power.production.current -->
    <app-feature-list-item
      *ngIf="powerOutput$ | async | ready as feature"
      label="{{
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.ELECTRICAL_OUTPUT' | translate
      }}:"
      [description]="
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.ELECTRICAL_OUTPUT_TOOLTIP'
          | translate
      "
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    ></app-feature-list-item>

    <!-- fuelCell.sensors.temperature.return -->
    <app-feature-list-item
      *ngIf="fuelCellReturnTemperature$ | async | ready as feature"
      label="{{
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.RETURN_TEMP_SENSOR'
          | translate
      }}:"
      [description]="
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.RETURN_TEMP_SENSOR_TOOLTIP'
          | translate
      "
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    ></app-feature-list-item>
  </app-feature-list-container>
  <app-feature-list-container *ngIf="fuelCellStatistics$ | async | ready as feature">
    <!-- fuelCell.statistics.operationHours -->
    <app-feature-list-item
      label="{{
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.HOURS_RUN' | translate
      }}:"
      [description]="
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.HOURS_RUN_TOOLTIP' | translate
      "
      value="{{ feature | value2: featurePropertyKey.operationHours }} {{
        feature | unit: featurePropertyKey.operationHours
      }}"
      [attr.data-feature]="feature.feature + '/operationHours'"
      [error]="feature | error"
    ></app-feature-list-item>

    <!-- fuelCell.statistics.productionStarts -->
    <app-feature-list-item
      label="{{
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.START_PROD_COUNTER'
          | translate
      }}:"
      [description]="
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.START_PROD_COUNTER_TOOLTIP'
          | translate
      "
      [value]="feature | value2: featurePropertyKey.productionStarts"
      [attr.data-feature]="feature.feature + '/productionStarts'"
      [error]="feature | error"
    ></app-feature-list-item>

    <!-- fuelCell.statistics.productionHours -->
    <app-feature-list-item
      label="{{
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.PROD_HOURS' | translate
      }}:"
      [description]="
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.PROD_HOURS_TOOLTIP'
          | translate
      "
      value="{{ feature | value2: featurePropertyKey.productionHours }} {{
        feature | unit: featurePropertyKey.productionHours
      }}"
      [attr.data-feature]="feature.feature + '/productionHours'"
      [error]="feature | error"
    ></app-feature-list-item>
    <!-- heating.boiler.sensors.temperature.commonSupply -->
    <app-feature-list-item
      *ngIf="boilerCommonSupplyTemperature$ | async | ready as feature"
      label="{{
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.FLOW_TEMP_SENSOR' | translate
      }}:"
      [description]="
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.FLOW_TEMP_SENSOR_TOOLTIP'
          | translate
      "
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    ></app-feature-list-item>

    <!-- heating.sensors.temperature.return -->
    <app-feature-list-item
      *ngIf="returnFlowTemperature$ | async | ready as feature"
      label="{{
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.RETURN_TEMP_SENSOR_LOW_LOSS'
          | translate
      }}:"
      [description]="
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.RETURN_TEMP_SENSOR_LOW_LOSS'
          | translate
      "
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    ></app-feature-list-item>
  </app-feature-list-container>
  <app-feature-list-container>
    <!-- fuelCell.operating.modes.active -->
    <app-feature-list-item
      *ngIf="fuelCellActiveMode$ | async | ready as feature"
      label="{{
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.OPERATING_MODE' | translate
      }}:"
      [description]="
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.OPERATING_MODE_TOOLTIP'
          | translate
      "
      [value]="feature | value2: featurePropertyKey.value | translateFuelCellMode"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
      [replaceValueWithElement]="!!feature"
    >
      <mat-form-field
        alternativeElement
        *ngIf="fuelCellActiveMode$ | async | ready as feature"
        class="select-fuel-cell-operating-mode flex-[100%] max-w-[100%]"
        mat-select-height-small
      >
        <mat-select
          data-at-fuel-cell-operating-mode-select
          (selectionChange)="onFuelCellOperatingModeChange($event)"
          name="{{
            '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.OPERATING_MODE_SELECT'
              | translate
          }}"
          [value]="fuelCellOperatingMode"
          [attr.data-feature]="feature.feature"
          [disabled]="!(feature | executable: 'setMode')"
          [placeholder]="feature | value2: featurePropertyKey.value | translateFuelCellMode"
          fieldTextContentTooltip
        >
          <mat-option
            gtm="onSelect"
            gtmAction="Fuel Cell Operating Mode"
            gtmCategory="Fuel Cell"
            fieldTextContentTooltip
            *ngFor="let mode of feature.commands?.setMode?.params?.mode?.constraints?.enum"
            [value]="mode"
          >
            {{ mode | translateFuelCellMode }}
          </mat-option>
        </mat-select>
      </mat-form-field></app-feature-list-item
    >

    <!-- fuelCell.operating.phase -->
    <app-feature-list-item
      *ngIf="fuelCellOperatingPhase$ | async | ready as feature"
      label="{{
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.STATUS' | translate
      }}:"
      [description]="
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.STATUS_TOOLTIP' | translate
      "
      [value]="feature | value2: featurePropertyKey.value | translateFuelCellPhase"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    ></app-feature-list-item>

    <!-- fuelCell.sensors.temperature.supply -->
    <app-feature-list-item
      *ngIf="fuelCellSupplyTemperature$ | async | ready as feature"
      label="{{
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.FUEL_FLOW_TEMP_SENSOR'
          | translate
      }}:"
      [description]="
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.FUEL_FLOW_TEMP_SENSOR_TOOLTIP'
          | translate
      "
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    ></app-feature-list-item>
    <!-- heating.burners.0.modulation -->
    <app-feature-list-item
      *ngIf="burnerModulation$ | async | ready as feature"
      label="{{
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.MODULATION' | translate
      }}:"
      [description]="
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.MODULATION_TOOLTIP'
          | translate
      "
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    ></app-feature-list-item>

    <!-- heating.sensors.temperature.hydraulicSeparator -->
    <app-feature-list-item
      *ngIf="hydraulicSeparatorTemperature$ | async | ready as feature"
      label="{{
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.FLOW_TEMP_SENSOR_LOW_LOSS_HEADER'
          | translate
      }}:"
      [description]="
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.FLOW_TEMP_SENSOR_LOW_LOSS_HEADER'
          | translate
      "
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    ></app-feature-list-item>
  </app-feature-list-container>
  <ng-container *ngrxLet="bufferTemperatureMain$ as bufferTemperatureMain">
    <ng-container *ngrxLet="heatingBoilerTemperature$ as heatingBoilerTemperature">
      <app-feature-list-container *ngIf="bufferTemperatureMain || heatingBoilerTemperature">
        <!-- heating.buffer.sensors.temperature.main -->
        <app-feature-list-item
          *ngIf="bufferTemperatureMain"
          label="{{
            '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.BUFFER_TEMPERATURE_MAIN'
              | translate
          }}:"
          [description]="
            '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.BUFFER_TEMPERATURE_MAIN_TOOLTIP'
              | translate
          "
          value="{{ bufferTemperatureMain | value2: featurePropertyKey.value }} {{
            bufferTemperatureMain | unit: featurePropertyKey.value
          }}"
          [attr.data-feature]="bufferTemperatureMain.feature"
          [error]="bufferTemperatureMain | error"
        ></app-feature-list-item>
        <!-- heating.boiler.temperature -->
        <app-feature-list-item
          *ngIf="heatingBoilerTemperature"
          label="{{
            '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.BOILER_TEMP' | translate
          }}:"
          [description]="
            '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.BOILER_TEMP_TOOLTIP'
              | translate
          "
          value="{{ heatingBoilerTemperature | value2: featurePropertyKey.value }} {{
            heatingBoilerTemperature | unit: featurePropertyKey.value
          }}"
          [attr.data-feature]="heatingBoilerTemperature.feature"
          [error]="heatingBoilerTemperature | error"
        ></app-feature-list-item>
      </app-feature-list-container>
    </ng-container>
  </ng-container>
</app-feature-details-grid>
